import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_119_959",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z",
			fill: "#FFF8EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 14V13C3.68629 13 1 10.3137 1 7H0H-1C-1 11.4183 2.58172 15 7 15V14ZM14 7H13C13 10.3137 10.3137 13 7 13V14V15C11.4183 15 15 11.4183 15 7H14ZM7 0V1C10.3137 1 13 3.68629 13 7H14H15C15 2.58172 11.4183 -1 7 -1V0ZM7 0V-1C2.58172 -1 -1 2.58172 -1 7H0H1C1 3.68629 3.68629 1 7 1V0Z",
			fill: "#F0D078",
			mask: "url(#path-1-inside-1_119_959)"
		})
	]
});
export { SvgAlertCircle as ReactComponent };
